import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseButtonComponent, ConfirmPopupComponent } from '@d-components';
import { ModalSize } from '@d-constants';
import { ModalService } from '@d-services';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-cancel-button',
  templateUrl: './cancel-button.component.html',
  styleUrls: ['./cancel-button.component.scss'],
  standalone: true,
  providers: [TranslateService],
  // imports: [BaseButtonComponent]
  imports: [CommonModule, TooltipModule, TranslateModule, BaseButtonComponent],
})
export class CancelButtonComponent implements OnInit {
  @Input() isChanged: boolean = false;
  @Input() label = 'CANCEL';
  @Output() onClick: EventEmitter<any> = new EventEmitter();

  constructor(private modalService: ModalService) {}

  ngOnInit(): void {}

  handleCancel() {
    if (this.isChanged) {
      this.modalService
        .openModal(ConfirmPopupComponent, {
          title: 'CONFIRM_LEAVE_TITLE',
          confirmMessage: 'CONFIRM_LEAVE_BODY',
          showReason: false,
          cancelText: 'STAY',
          submitText: 'LEAVE',
          size: ModalSize.MEDIUM,
        })
        .subscribe((val) => {
          if (val.actionType === 'submit') {
            this.onClick.emit();
          }
        });
    } else this.onClick.emit();
  }
}
